import React, { useState, useEffect } from 'react';
import './event.dropdown.scss';
import { useRecoilState } from 'recoil';
import { stepsEnabledAtom } from '../../atoms/camp.atom';

const EventsDropdown = ({ selectedEvent, setSelectedEvent, eventList }) => {
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const [showPane, setShowPane] = useState(false);
  const [rotate, setRotate] = useState('');
  const [tagOn, setTagOn] = useState(false);

  useEffect(() => {
    setShowPane(stepsEnabled ? true : false);
  }, [stepsEnabled]);

  const rotateArrow = () => {
    setRotate(rotate === 'rotate-180' ? 'rotate-360' : 'rotate-180');
  };

  const handleSelectboxClick = (e) => {
    setShowPane(!showPane);
    rotateArrow();
  };

  const handleClick = (id) => {
    setSelectedEvent(id);
    setShowPane(false);
    rotateArrow();
  };

  const getEventId = (id) => {
    switch (id) {
      case 1:
        return 'guardian-step-feelings';
      case 2:
        return 'guardian-step-creative';
      case 3:
        return 'guardian-step-dream';
      case 4:
        return 'guardian-step-notes';
      case 5:
        return 'guardian-step-promise';
      default:
        break;
    }
  };

  return (
    <div className="insights-calendar-dropdown-container">
      <div
        className={`filter event-selectbox ${tagOn ? 'event-selected' : ''}`}
        onClick={handleSelectboxClick}
      >
        <div className="selected-event">
          <div className="insights-event-dropdown-wrapper">
            {
              eventList[
                eventList.findIndex((event) => event.id === selectedEvent)
              ]?.name
            }
          </div>
        </div>
        <div className={`selectbox-arrow ${rotate}`}></div>
      </div>
      <div
        className={`tag-list-pane ${showPane ? 'show' : 'hide'}`}
        id="step-six"
      >
        {eventList.map((event, key) => {
          return (
            <div
              className={`event-item ${
                selectedEvent === event?.id && 'selected'
              }`}
              onClick={() => handleClick(event?.id)}
              key={`item-${key}`}
              id={getEventId(event?.id)}
            >
              <div className="">{event.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventsDropdown;
